import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col w-full space-y-4"
}

import { computed, ref, watch } from "vue";
import { useFriendsStore } from "@/store/useFriendsStore";
import { useAuthStore } from "@/store/useAuthStore";
import UserManageView from "@/components/Friends/UserManageView.vue";
import TitleMedium from "@/components/Titles/TitleMedium.vue";
import InputCheckbox from "@/components/Form/InputCheckbox.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserManageViewContainer',
  setup(__props) {

const friendsStore = useFriendsStore();
const authStore = useAuthStore();

const friendsInfos = computed(() => {
  return friendsStore.friendsInfos;
});

const currentUser = computed(() => {
  return authStore.currentUser;
});

const common = ref(authStore.currentUser.common);

watch(
  () => common.value,
  () => {
    authStore.updateCommon(common.value);
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleMedium, { text: "Tailor your map view" }),
    _createVNode(UserManageView, {
      friend_info: { friendId: currentUser.value.id }
    }, null, 8, ["friend_info"]),
    _hoisted_2,
    (friendsInfos.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(friendsInfos.value, (friend_info) => {
            return (_openBlock(), _createBlock(UserManageView, {
              key: friend_info.friendId,
              friend_info: friend_info
            }, null, 8, ["friend_info"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(InputCheckbox, {
      label: "See only common countries",
      id: "common",
      error: "common",
      modelValue: common.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((common).value = $event)),
      name: "common"
    }, null, 8, ["modelValue"])
  ]))
}
}

})